import { useTranslation } from "react-i18next";
import { getCanonicalTitle } from "../../../../../common/util/Incentives/IncentiveRegistry";
import { ROUTE_PATHS } from "../../../../../common/enums/routing-enums";
import TEALIUM from "../../../../../common/enums/tealium-enums";
import { track } from "../../../../../common/util/tealium";
import defaultContent from "../../../../../content/groupManagement";
import { ActionCard } from "../../ActionCard/ActionCard";
import type { CardComponentProps } from "../ActionCenter";
import { ActionCardRecord } from "../../../../../services/GroupManagementOverview/groupManagementOverviewAPI.types";

export const GroupSopTrackingCard = ({ enabled }: CardComponentProps) => {
  const { t } = useTranslation(["groupManagement", "navigation"]);
  const title = getCanonicalTitle({ id: "groupSopTracking" }, t, {});

  const data = {
    counts: [
      {
        count: 0,
        countFormatted: "0",
        key: "upForRenewal",
      },
      {
        count: 0,
        countFormatted: "0",
        key: "abosOnSop",
      },
      {
        count: 0,
        countFormatted: "0",
        key: "customersOnSop",
      },
    ],
  };

  const transformRows = () => {
    return (
      data?.counts?.map((record: ActionCardRecord) => ({
        kpiValue: record.countFormatted,
        kpiName: t(record.key, defaultContent[record.key] ?? record.key),
      })) ?? []
    );
  };

  const handleTracking = () => {
    track(
      TEALIUM.U_TAG_METHOD.LINK,
      TEALIUM.EVENT_NAME.CLICK_ACTION,
      TEALIUM.CATEGORY.GROUP_MANAGEMENT,
      "sop_group_tracking",
      "",
      "sop_group_tracking",
    );
  };

  return (
    <ActionCard
      title={title}
      to={ROUTE_PATHS.SOP_REPORT}
      rows={transformRows()}
      isLoading={false}
      disabled={!enabled}
      onClickTracking={handleTracking}
    />
  );
};
